export default "__VITE_ASSET__BqYJJkYx__"